import React, { Component, useState, useEffect } from "react";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import Column from "./Column";
import { Card, Button, Modal, Table, Alert, Spinner } from "react-bootstrap";
import swal from "sweetalert";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
export default function GoCategory() {
  const history=useHistory()
  const [spinner, setSpinner] = useState(true);
  const [name, setName] = useState("");
  const [catKey, setCatKey] = useState("");
  const [catColor, setCatColor] = useState("");
  const [catUrl, setCatUrl] = useState("");
  const [banners, setBanners] = useState([]);
  const [image, setImage] = useState(null);
  const [imageData, setImageData] = useState(null);
  const [show, setShow] = useState(false);
  const [dragSpinner, setDragSpinner] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [taskList, setTasks] = useState("");
  function onDragEnd(val) {
    setDragSpinner(true);
    const { draggableId, source, destination } = val;
    var b = taskList[source.index];
    taskList[source.index] = taskList[destination.index];
    taskList[destination.index] = b;
    let arrId = [];
    taskList.map((val) => {
      arrId.push(val._id);
    });
    let idArr = {
      arrID: arrId,
    };
    axios
      .put(Baseurl.baseurl + `/go-ui/update-category-index`, idArr)
      .then((response) => {
        if (response.data.status) {
          getData();
        }
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  }
  const handleShow = () => {
    setUpdateStatus(false);
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
  };
  function getData() {
    axios.get(Baseurl.baseurl + `/go-ui/get-category`).then((res) => {
      setDragSpinner(false);
      setSpinner(false);
      setTasks(res.data.categories);
      setBanners(res.data.categories);
    })
    .catch((err) => {
      if(err.toString()==="Error: Network Error")
      {
        history.push('/offline')
      }
      else
      {
        history.push('/400')
      }
  })
  }
  useEffect(() => {
    getData();
  }, []);
  const onChangePicture = (e) => {
    if(e.target.files[0]&&e.target.files[0].size/1024<3000){
      if (e.target.files[0]) {
        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = function (val) {
          var image = new Image();
          image.src = val.target.result;
          image.onload = function () {
            var height = this.height;
            var width = this.width;
            setImage(e.target.files[0]);
            setImageData(reader.result);
            // if (height == 160 && width == 200) {
            //   setImage(e.target.files[0]);
            //   setImageData(reader.result);
            // }
            // else
            //   {
            //   swal("Oops", "image Width×Height should be 160×200", "error", {
            //     button: "Done",
            //     timer: 2000,
            //   });
            //   setImageData(null);
            // return false;
            // }
          };
        };
      }
    }
    else
    {
      swal("Oops", "image size should be less than 200KB", "error", {
        button: "Done",
        timer: 2000,
      });
      setImageData(null)
    }
   
  };
  function saveBanner(e) {
    e.preventDefault();
    const data = new FormData();
    data.append("category", `${name}`);
    data.append("key", catKey);
    data.append("url", `${catUrl}`);
    data.append("color", `0XFF${catColor}`);
    data.append("image", image);
    var config = {
      method: "post",
      url: `${Baseurl.baseurl}/go-ui/add-category`,
      data: data,
    };

    axios(config)
      .then(function(response) {
        if (response.data.status) {
          getData();
          setName("");
          setImage(null);
          setImageData(null);
          swal("Added", response.data.message, "success", { button: "Done" ,timer: 1000,});
        } else {
          swal("Oops", response.data.message, "error", { button: "Done",timer: 1000, });
        }
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })

    handleClose();
  }
  return (
    <Card>
      <Modal show={show} onHide={handleClose}>
        <Modal.Body>
          <div className="card">
            <div className="card-body">
              <div className="row ">
                <div className="col-sm-4 mt-2">
                  <label>Category</label>
                </div>
                <div className="col-sm-8">
                  <input
                    type="text"
                    className="form-control"
                    id="val-username"
                    name="val-username"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter Category Name"
                  />
                </div>
              </div>
              <div className="row mt-4 ">
                <div className="col-sm-4 mt-2">
                  <label>Category Key</label>
                </div>
                <div className="col-sm-8">
                  <input
                    type="number"
                    className="form-control"
                    id="val-username"
                    name="val-username"
                    value={catKey}
                    onChange={(e) => setCatKey(e.target.value)}
                    placeholder="Enter 2 digit Key"
                    maxLength={2}
                  />
                </div>
              </div>
              <div className="row mt-4 ">
                <div className="col-sm-4 mt-2">
                  <label>Category Color</label>
                </div>
                <div className="col-sm-8">
                  <input
                    type="text"
                    className="form-control"
                    id="val-username"
                    name="val-username"
                    value={catColor}
                    onChange={(e) => setCatColor(e.target.value)}
                    placeholder="Enter color"
                  />
                </div>
              </div>
              <div className="row mt-4 ">
                <div className="col-sm-4 mt-2">
                  <label>Category Url</label>
                </div>
                <div className="col-sm-8">
                  <input
                    type="url"
                    className="form-control"
                    id="val-username"
                    name="val-username"
                    value={catUrl}
                    onChange={(e) => setCatUrl(e.target.value)}
                    placeholder="Enter Url"
                  />
                </div>
              </div>
              <div className="row mt-4 ">
                <div className="col-sm-4 mt-2">
                  <label className="col-form-label" htmlFor="val-range">
                    Category Image
                    <span className="text-danger">*</span>
                  </label>
                </div>
                <div className="col-sm-8">
                  <div className="register_profile_image mt-2">
                    <input
                      id="profilePic"
                      type="file"
                      onChange={(e) => {
                        onChangePicture(e);
                      }}
                    />
                  </div>
                  <small>image should be less than 200KB and size 150×200</small>
                  {imageData && (
                    <div
                      style={{
                        marginTop: "5px",
                        width: 180,
                        height: 100,
                        aspectRatio: 1 * 1.4,
                      }}
                      className="previewProfilePic"
                    >
                      <img
                        className="playerProfilePic_home_tile"
                        style={{
                          resizeMode: "cover",
                          width: "100%",
                          height: "100%",
                        }}
                        src={imageData}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {updateStatus ? null : (
            <Button
              variant="primary"
              onClick={(e) => {
                saveBanner(e);
              }}
            >
              submit
            </Button>
          )}
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <div>
        <div style={{ padding: 20 }} className="flex-container">
          <div>
            <div>
              <button className="btn btn-primary float-right" onClick={handleShow}>
                Add Category
              </button>
            </div>
            <Table>
              <thead>
                <div className="row">
                  <div className="ml-4">
                    <strong>Category</strong>
                  </div>
                  <div className="col-sm-2">
                    <strong>Category Key</strong>
                  </div>
                  <div className="col-sm-2">
                    <strong>Category Url</strong>

                  </div>
                  <div className="col-sm-1">
                    <strong>Color</strong>
                  </div>
                  <div className="col-sm-4">
                    <strong>Image</strong>
                  </div>
                </div>
              </thead>
            </Table>
            {dragSpinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <>
                {spinner ? (
                  <div className="text-center">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : (
                  <DragDropContext onDragEnd={onDragEnd}>
                    <div className="wrapper">
                      <Column
                        className="column"
                        droppableId="1"
                        list={taskList}
                        type="TASK"
                        setTask={setTasks}
                      />
                    </div>
                  </DragDropContext>
                )}
              </>
            )}

            <>
              {!banners && (
                <Alert
                  variant="success"
                  className="alert-dismissible fade show text-center"
                >
                  Add Banners
                </Alert>
              )}
            </>
          </div>
        </div>
      </div>
    </Card>
  );
}
